import { createRoot } from "react-dom/client";
import "./index.css";
import "./initChatSuiteAuth";
import { applyChatTheme, readChatTheme } from "@/lib/theme/chatTheme";
import { readChatAccent } from "@/lib/theme/chatAccent";
import {
  installChatCacheGuard,
  syncChatBuildVersionOnLaunch,
} from "@/lib/cache/chatSwBootstrap";
import { syncSuiteUserIdFromQuery } from "./suiteSession";
import App from "./App";

applyChatTheme(readChatTheme(), readChatAccent());
syncSuiteUserIdFromQuery();
installChatCacheGuard();
syncChatBuildVersionOnLaunch();

// Pas de StrictMode : le double-montage en dev rejouait le splash (saut / reprise).
createRoot(document.getElementById("root")!).render(<App />);
